import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calllog',
  templateUrl: './calllog.component.html',
  styleUrls: ['./calllog.component.css']
})
export class CallLogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
